import PropTypes from 'prop-types';
import { translate } from 'utils/translate';
import { useMemo } from 'react';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_REGISTRATION_NEW_CLIENT } from 'constants/featureGates';
import Button from '../Button';

const RegistrationSuccess = ({
  content,
  customer = {},
  btnContinueText,
  btnContinueType,
  btnExitText,
  btnExitType,
  onContinue,
  onExit,
}) => {
  const html = useMemo(() => {
    return translate(content || '', customer || {});
  }, [content, customer]);

  // "Terminar más tarde" belongs to the resumable onboarding (KYC), which is
  // native-app-only; hide it on any browser (see useFeatureGate rules).
  const canContinueOnboarding = useFeatureGate(FEATURE_REGISTRATION_NEW_CLIENT);

  const marginFix = useMemo(() => {
    return document.location.search.includes('previewMode') ? 'mt-4' : '';
  }, []);

  return (
    <div className='full-screen-container with-header'>
      <div className='screen-content'>
        <div className='block-rich-text' dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      <div className='screen-actions'>
        {btnContinueText ? (
          <Button
            className={marginFix}
            text={btnContinueText}
            type={btnContinueType}
            onClick={onContinue}
          />
        ) : null}
        {btnExitText && canContinueOnboarding ? (
          <Button
            className={marginFix}
            text={btnExitText}
            type={btnExitType}
            onClick={onExit}
          />
        ) : null}
      </div>
    </div>
  );
};

RegistrationSuccess.propTypes = {
  content: PropTypes.string.isRequired,
  customer: PropTypes.object,
  btnContinueText: PropTypes.string,
  btnContinueType: PropTypes.string,
  btnExitText: PropTypes.string,
  btnExitType: PropTypes.string,
  onContinue: PropTypes.func,
  onExit: PropTypes.func,
};

export default RegistrationSuccess;
